const REQUEST_CLEAR_FILTER = "REQUEST_CLEAR_FILTER";
const READY_CLEAR_FILTER = "READY_CLEAR_FILTER";
const REQUEST_CHANGE_STORE_CARSFILTER = "REQUEST_CHANGE_STORE_CARSFILTER";
const READY_CHANGE_STORE_CARSFILTER = "READY_CHANGE_STORE_CARSFILTER";
const CONFIRM_STORE_CARSFILTER = "CONFIRM_STORE_CARSFILTER";

const requestClearFilterAction = () => {
  return {
    type: REQUEST_CLEAR_FILTER,
  };
};

const responseClearFilterAction = (clearItems) => {
  return {
    type: READY_CLEAR_FILTER,
    clearItems,
  };
};

const handleClearFilter = () => {
  return (dispatch) => {
    dispatch(requestClearFilterAction());

    setTimeout(() => {
      dispatch(
        responseClearFilterAction({
          types: [],
          brands: [],
          groups: [],
          statuses: [],
          winterCompanies: [],
          sensors: [],
        })
      );
    }, 10);
  };
};

const requestChangeStoreCarsFilterAction = () => {
  return {
    type: REQUEST_CHANGE_STORE_CARSFILTER,
  };
};

const responseChangeStoreCarsFilterAction = (name, value) => {
  return {
    type: READY_CHANGE_STORE_CARSFILTER,
    payload: { name, value },
  };
};

const handleChangeStoreCarsFilter = (name, value) => {
  return (dispatch) => {
    dispatch(requestChangeStoreCarsFilterAction());
    setTimeout(() => {
      dispatch(responseChangeStoreCarsFilterAction(name, value));
    }, 10);
  };
};

const confirmCarsFilterAction = () => {
  return {
    type: CONFIRM_STORE_CARSFILTER,
  };
};

const confirmCarsFilter = () => {
  return (dispatch) => {
    dispatch(confirmCarsFilterAction());
  };
};

export {
  handleClearFilter,
  requestClearFilterAction,
  responseClearFilterAction,
  REQUEST_CLEAR_FILTER,
  READY_CLEAR_FILTER,
  handleChangeStoreCarsFilter,
  requestChangeStoreCarsFilterAction,
  responseChangeStoreCarsFilterAction,
  REQUEST_CHANGE_STORE_CARSFILTER,
  READY_CHANGE_STORE_CARSFILTER,
  CONFIRM_STORE_CARSFILTER,
  confirmCarsFilter,
};
